module.exports = __webpack_public_path__ + "static/media/search.73d0609a.svg";